<template>
  <div v-if="simulationData.modals.sell.blocks.length>0" class="modal" id="sellModal" tabindex="-1" aria-labelledby="sellModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sellModalLabel">
            <i class="fa-duotone fa-money-bills"></i> Sell
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <p>
              You will sell the following blocks:<br>
              <span v-for="block in modalBlocks">
              #{{ block.id}}
              </span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary me-auto" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary float-end" @click="sell">
              <i class="fa-duotone fa-money-bills"></i> Sell
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Modal} from 'bootstrap'
import Simulation from "@/views/Simulation/Simulation.vue";

export default {
  name: "Sell",
  components: { Simulation },
  props: ["initData", "contents", "simulationData"],
  data() {
    return {
      Simulation
    }
  },
  computed: {
    modalBlocks() {
      return this.simulationData.modals.sell.blocks
    },
    content() {
      return this.contents.sellModal
    },
  },
  methods: {
    sell(){
      this.Simulation.methods.action(this, 24, this.modalBlocks,null)

      //CLOSE MODAL
      let modalInstance = Modal.getInstance(document.getElementById("sellModal"));
      modalInstance.hide();
    },
    openModal(e, blocks, map) {
      e.simulationData.modals.sell.blocks = blocks

      setTimeout(() => {
        let modalInstance = new Modal(document.getElementById("sellModal"));
        modalInstance.show();
      }, 0);
    }
  },
};
</script>

<style scoped>

</style>